var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "k-grid",
      style: {
        display: "block",
        position: "absolute",
        zIndex: 20000,
        padding: "4px 6px",
        top: _vm.top + "px",
        left: _vm.left + "px"
      }
    },
    [
      _c("table", { staticClass: "k-grid-table" }, [
        _c("tbody", [
          _c(
            "tr",
            [
              _c("td", { staticClass: "k-master-row k-alt" }, [
                _c("span", { class: _vm.hintIcon })
              ]),
              _vm._v(" "),
              _vm._l(_vm.filteredFields, function(field, index) {
                return _c(
                  "td",
                  { key: index, staticClass: "k-master-row k-alt" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatdata(_vm.dataItem, field)) +
                        "\n        "
                    )
                  ]
                )
              })
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }